import { render, staticRenderFns } from "./DigiDotPortalLink.vue?vue&type=template&id=260e167e&"
import script from "./DigiDotPortalLink.vue?vue&type=script&lang=js&"
export * from "./DigiDotPortalLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports